import React, { useState } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import {
  ProfileHostingIcon,
  OnlineBookingSystemIcon,
  SecuredPaymentIcon,
  Analytics,
  ChatIconRed,
  CustomerSupportIcon,
} from "../../../../../constant/imagePath";
import classes from "./HowDoesPricingWork.module.css";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { Button } from "../../../../../stories/Button/Button";

export default function HowDoesPricingWork({ show, setShow }) {
  const iconsWithTitle = [
    { icon: ProfileHostingIcon, label: "Profile Hosting" },
    { icon: OnlineBookingSystemIcon, label: "Online booking system" },
    { icon: SecuredPaymentIcon, label: "Secured payment processing" },
    { icon: Analytics, label: "Analytics and insights" },
    { icon: ChatIconRed, label: "Instant messaging with students" },
    { icon: CustomerSupportIcon, label: "Customer support" },
  ];

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"612px"}
        header={
          <>
            <h4
              style={{
                ...Fonts.h4,
                fontSize: "26px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              How does pricing work?
            </h4>
            <p
              className={classes.tagline}
              style={{
                ...Fonts.p2,
                color: Colors.neutralShadesOfDimGray,
              }}
            >
              Lytesnap charges 10% of your listed lesson price
            </p>
          </>
        }
      >
        <div className={classes.modalContent}>
          {/* What We Offer */}
          <div className={classes.whatWeOffer}>
            <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
              What we offer
            </h5>
            {/* Table */}
            <table>
              <tr>
                {iconsWithTitle?.slice(0, 3)?.map((item, i) => {
                  return (
                    <td
                      style={
                        i === 0
                          ? {
                              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                              borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                          : i === 2
                          ? {
                              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                              borderLeft: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                          : {
                              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                      }
                    >
                      <div
                        className={`${[classes.card, classes.mb36].join(" ")}`}
                      >
                        <img src={item?.icon} />
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.label}
                        </p>
                      </div>
                    </td>
                  );
                })}
              </tr>
              <tr>
                {iconsWithTitle?.slice(3)?.map((item, i) => {
                  return (
                    <td
                      style={
                        i === 0
                          ? {
                              borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                          : i === 2
                          ? {
                              borderLeft: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                          : {
                              borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                            }
                      }
                    >
                      <div
                        className={`${[classes.card, classes.mb36].join(" ")}`}
                      >
                        <img src={item?.icon} />
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.label}
                        </p>
                      </div>
                    </td>
                  );
                })}
              </tr>
            </table>
          </div>
          <div
            className={classes.btnBox}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
          >
            <Button
              label={"Got it"}
              primary={true}
              size={"Large"}
              onClick={() => setShow(false)}
            />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
}
